"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.ListBox = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
exports.ListBox = react_1.forwardRef(ListBoxInner);
function ListBoxInner(props, ref) {
    var items = props.items, components = props.components, loading = props.loading, highlightedIndex = props.highlightedIndex, getItemProps = props.getItemProps, itemToString = props.itemToString, createNewItem = props.createNewItem, isItemSelected = props.isItemSelected, onItemClick = props.onItemClick, tabIndex = props.tabIndex, rest = __rest(props, ["items", "components", "loading", "highlightedIndex", "getItemProps", "itemToString", "createNewItem", "isItemSelected", "onItemClick", "tabIndex"]);
    var classes = styles_1.useStyles(exports.createStyles).classes;
    var CreateItem = components.CreateItem, AppendItem = components.AppendItem, EmptyItem = components.EmptyItem, Item = components.Item, LoadingItem = components.LoadingItem, PrependItem = components.PrependItem;
    return (react_1.default.createElement("div", __assign({ ref: ref, tabIndex: tabIndex }, rest),
        react_1.default.createElement("ul", { className: classes.list, tabIndex: tabIndex },
            PrependItem && react_1.default.createElement(PrependItem, null),
            loading && react_1.default.createElement(LoadingItem, null),
            !loading && createNewItem && !(items === null || items === void 0 ? void 0 : items.length) && react_1.default.createElement(CreateItem, null),
            !loading && !createNewItem && !(items === null || items === void 0 ? void 0 : items.length) && react_1.default.createElement(EmptyItem, null),
            items.map(function (item, index) {
                var _a = getItemProps({ item: item, index: index }), onClick = _a.onClick, itemProps = __rest(_a, ["onClick"]);
                return (react_1.default.createElement(Item, __assign({ key: "" + item + index, item: item, index: index, highlighted: highlightedIndex === index, itemToString: itemToString, selected: !!(isItemSelected === null || isItemSelected === void 0 ? void 0 : isItemSelected(item)), onClick: function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        onItemClick ? onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick.apply(void 0, __spreadArrays([item], args)) : onClick === null || onClick === void 0 ? void 0 : onClick.apply(void 0, args);
                    } }, itemProps)));
            }),
            AppendItem && react_1.default.createElement(AppendItem, null))));
}
exports.createStyles = function (theme) { return ({
    list: {
        border: 0,
        borderRadius: 0,
        boxShadow: 'none',
        maxHeight: 'auto',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        backgroundColor: theme.pallete.surface.main,
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '100%',
    },
}); };
//# sourceMappingURL=ListBox.js.map